
module.exports = class RoleMakerButton extends React.Component
  displayName: 'RoleMakerButton'

  constructor: (props) ->
      super(props)
      # Expects: @props.
      # my_accepted_roles
      @state = { }

  render: =>

      if @props.tool_selected is 'rolemaker'
          card_className = 'card light_green'
      else
          card_className = 'card light_gray'

      <div className={card_className}>
        <div className="card-body">
            <h2 className="card-title">
                <button className='btn btn-primary'
                        onClick={ @props.onClick.bind(this, {tools: 'rolemaker', show_this: 'rolemaker'}) }>
                    role maker
                </button>
            </h2>
            <p className="card-text">
                This is how you assign roles.
            </p>
        </div>
      </div>
